export interface SystemInfoBuild {
  model: string;
  manufacturer: string;
  buildVersion: string;
}

export interface SystemInfoWifiNetwork {
  macAddress: string | null;
  signalStrength: number | null;
  ssid: string | null;
  status: string;
}

export interface SystemInfoEthernetNetwork {
  status: string;
  macAddress: string | null;
  cable: string | null;
}

export enum TizenMemoryStatus {
  NORMAL = "NORMAL",
  WARNING = "WARNING"
}

export interface TizenSystemInfoMemory {
    status: TizenMemoryStatus;
}

export interface SystemInfoMemory {
  total: string | null;
  available: string | null;
  status?: TizenMemoryStatus | null;
}

export class PlatformDeviceInfo {

    constructor(
        public macAddress: string | null,
        public build?: SystemInfoBuild,
        public wifi?: SystemInfoWifiNetwork,
        public ethernet?: SystemInfoEthernetNetwork,
    ) {}

};